import PuxTranslate from "../../../../../global/components/PuxTranslate/PuxTranslate.vue";

// @vue/component
export default {
  name: "ModuleMuendlicherBerichtPreview",
  components: {
    PuxTranslate,
  },
};
